const API_URL = process.env.NEXT_PUBLIC_API_URL
const REST_API_URL = process.env.NEXT_PUBLIC_REST_API_URL || `${API_URL}/api`
const REST_API_PROXY_ENABLED = process.env.NEXT_PUBLIC_USE_API_PROXY === 'true'
const REST_PROXY_API_URL = REST_API_PROXY_ENABLED
  ? typeof window === 'undefined'
    ? REST_API_URL
    : process.env.NEXT_PUBLIC_APP_URL + '/api'
  : REST_API_URL
const ASSETS_BASE_URL = REST_API_PROXY_ENABLED
  ? process.env.NEXT_PUBLIC_APP_URL + '/api/images'
  : API_URL
const GRAPH_API_URL =
  process.env.NEXT_PUBLIC_GRAPH_API_URL || `${API_URL}/graphql`
const BACKEND_URL = String(process.env.NEXT_PUBLIC_BACKEND_URL)
const UPLOAD_ENDPOINT = `${API_URL}/api/image/upload`
const BASIC_AUTH =
  String(process.env.API_BASIC_AUTH) === '1' ||
  String(process.env.API_BASIC_AUTH) === 'false' ||
  false
const REST_API_TOKEN = process.env.NEXT_PUBLIC_REST_API_TOKEN ?? ''

export default {
  DEBUG: false,
  API_URL,
  REST_API_URL,
  REST_PROXY_API_URL,
  ASSETS_BASE_URL,
  REST_API_PROXY_ENABLED,
  GRAPH_API_URL,
  UPLOAD_ENDPOINT,
  BACKEND_URL,
  BASIC_AUTH,
  REST_API_TOKEN,
  IGNORE_API_SSL_ERRORS:
    String(process.env.IGNORE_API_SSL_ERRORS) === 'true' ||
    String(process.env.IGNORE_API_SSL_ERRORS) === '1' ||
    false,
  AUTH_PROVIDER: process.env.NEXT_PUBLIC_AUTH_PROVIDER ?? 'ecps',
}
